<template>
  <div class="header">
    <b-container>
      <b-navbar>
        <b-navbar-brand href="#">
          <img :src="img" alt="" class="head_img" />
        </b-navbar-brand>
        <b-navbar-nav class="ml-auto">
          <b-nav-item @click="Herf('home')" class="pr-5" style="position: relative">
            首页
            <div class="bottom-line" v-show="locationPpathname == 'home'"></div>
          </b-nav-item>
          <b-nav-item class="pr-5" style="position: relative" @click="Herf('case1')">
            猪肉
            <div class="bottom-line" v-show="locationPpathname == 'case1'"></div>
          </b-nav-item>
          <b-nav-item class="pr-5" style="position: relative" @click="Herf('case2')">
            牛肉
            <div class="bottom-line" v-show="locationPpathname == 'case2'"></div>
          </b-nav-item>
          <b-nav-item class="pr-5" style="position: relative" @click="Herf('case3')">
            羊肉
            <div class="bottom-line" v-show="locationPpathname == 'case3'"></div>
          </b-nav-item>
          <b-nav-item class="pr-5" style="position: relative" @click="Herf('case4')">
            鸡肉
            <div class="bottom-line" v-show="locationPpathname == 'case4'"></div>
          </b-nav-item>
          <b-nav-item class="pr-5" style="position: relative" @click="Herf('team')">
            团队
            <div class="bottom-line" v-show="locationPpathname == 'team'"></div>
          </b-nav-item>
          <b-nav-item class="pr-5" @click="Herf('call')" style="position: relative">
            联系我们
            <div class="bottom-line" v-show="locationPpathname == 'call'"></div>
          </b-nav-item>
        </b-navbar-nav>

      </b-navbar>
    </b-container>
  </div>
</template>

<script>
  import axios from "axios";
  import local from "../utils/local";
  import {
    index
  } from "../api/api";

  export default {
    data() {
      return {
        locationPpathname: "",
        domain: "",
        img: "",
        name: "",
      };
    },
    methods: {
      Herf(data) {
        this.locationPpathname = data;
        if (data == "home" || data == "team" || data == "call") {

          this.$router.push("/home");

          this.$nextTick(() => {
            this.$emit("name", this.locationPpathname);
          });
        } else {
          this.$router.push({
            path: '/case',
            query: {
              data: this.locationPpathname.slice(4)
            }
          });

          this.$nextTick(() => {
            this.$emit("name", this.locationPpathname);
          });
        }
      },
      getInfo() {
        index("", 1, 9,'').then((res) => {
          this.img = res.data.data.msg[0].logo;
        });
      },
    },
    mounted() {
      this.locationPpathname = "home";
    },
    created() {
      this.getInfo();
    },
  };
</script>

<style type="text/css">
  .header {
    box-shadow: 0 8px 10px -6px #d5d5d5;
    width: 100%;
    height: 80px;
    background-color: #fff;
    width: 100%;
    position: fixed;
    z-index: 1000;
  }

  .head_img {
    width: 37px;
  }

  .name {
    font-size: 16px;
    font-weight: bold;
    color: #666;
  }

  .ym {
    font-size: 12px;
    color: #999;
  }

  .navbar-light .navbar-nav .nav-link {
    position: relative;
    font-size: 14px;
  }

  .navbar-light .navbar-nav .nav-link:hover {
    color: #28a6fc;
  }

  .bottom-line {
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    height: 2px;
    background: #28a6fc;
    color: #28a6fc;
    bottom: -5px;
  }
</style>